import React from 'react';
import { withI18n } from '@shopify/react-i18n';
import { Modal } from '@shopify/polaris';

interface ComposedPropsItem {
  onClose: () => void;
  onConfirm: () => void;
  isOpen: boolean;
}

const ConfirmDisconnectModal: React.FC<ComposedPropsItem> = ({
  onClose,
  onConfirm,
  isOpen,
  i18n
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={i18n.translate('AdminHTML.KlaviyoIntegration.DisconnectModal.title')}
      primaryAction={[
        {
          content: i18n.translate('AdminHTML.KlaviyoIntegration.DisconnectModal.remove'),
          onAction: onConfirm
          // loading: loading
        }
      ]}
      secondaryActions={[
        {
          content: i18n.translate('AdminHTML.Common.Action.close'),
          onAction: onClose
        }
      ]}>
      <p style={{ padding: '24px 20px' }}>
        {i18n.translate('AdminHTML.KlaviyoIntegration.DisconnectModal.description')}
      </p>
    </Modal>
  );
};

export default withI18n()(ConfirmDisconnectModal);
